// removed by extract-text-webpack-plugin
module.exports = {"app":"_3I6wl6PTpwkT6F8pLaIIaa"};


//////////////////
// WEBPACK FOOTER
// ./client/src/App.scss
// module id = 292
// module chunks = 0